import i18n, {initPromise} from '../i18n'
import localStorageKeys from './localStorageKeys'
import TextHelper from '../utils/text'

const getValidationText = (key) => i18n.t(key, {ns: 'validation'})

const getRealTimeValidationTextRes = async(key) => {
    await initPromise
    return i18n.t(key, {ns: 'validation'})
}

const formatMessage = (template, vars = {}) => {
    if (!template) return ''
    return template.replace(/:([a-zA-Z0-9_]+)/g, (_, k) => (vars[k] ?? ''))
}

const text = {
    required: (field, isMulti = false) =>
        formatMessage(getValidationText('required'), {field, isMulti: isMulti ? 'are' : 'is'}),
    length: (field, length, type) =>
        formatMessage(getValidationText('length'), {field, length, type}),
    value: (field, value, type) =>
        formatMessage(getValidationText('value'), {field, value, type}),
    invalid_field: (field, isMulti = false) =>
        formatMessage(getValidationText('invalid_field'), {field, isMulti: isMulti ? 'are' : 'is'}),
    has_protocol: (protocols) =>
        formatMessage(getValidationText('has_protocol'), {protocols: protocols.join(', ')}),
    has_number: (field) => formatMessage(getValidationText('has_number'), {field}),
    has_char: (field) => formatMessage(getValidationText('has_char'), {field}),
    has_case: (field, type) => formatMessage(getValidationText('has_case'), {field, type}),
    like_email: (field) => formatMessage(getValidationText('like_email'), {field}),
    digits: (field, length) => formatMessage(getValidationText('digits'), {field, length}),
    is_same: (field, match) => formatMessage(getValidationText('is_same'), {field, match}),
    should_select: (field) => formatMessage(getValidationText('should_select'), {field}),
    can_be_used: (field, length) => formatMessage(getValidationText('can_be_used'), {field, length}),
    must_be_type: (field, type) => formatMessage(getValidationText('must_be_type'), {field, type}),
    must_be_between: (field, min, max) =>
        formatMessage(getValidationText('must_be_between'), {field, min, max}),
    one_of: (field, data) => formatMessage(getValidationText('one_of'), {field, data: data.join(', ')}),
    invalid_file_size: (field, size) =>
        formatMessage(getValidationText('invalid_file_size'), {field, size}),
    invalid_file_type: (field) => formatMessage(getValidationText('invalid_file_type'), {field}),
    invalid_dimension: (field) => formatMessage(getValidationText('invalid_dimension'), {field}),
    choose_field: (field) => formatMessage(getValidationText('choose_field'), {field}),
    failed_load_file: () => getValidationText('failed_load_file'),
    end_time_validation: (field1, field2) =>
        formatMessage(getValidationText('end_time_validation'), {field1, field2})
}

export const realTimeValidationText = {
    required: async() => await getRealTimeValidationTextRes('real_time_validation_required'),
    length: async(length, type) => {
        const tpl = await getRealTimeValidationTextRes('real_time_validation_length')
        const lang = localStorage.getItem(localStorageKeys.LANGUAGE)
        return formatMessage(tpl, {length, type: lang === 'az' ? TextHelper.capitalizeFirstChar(type) : type})
    },
    has_number: async() => await getRealTimeValidationTextRes('real_time_validation_has_number'),
    has_char: async() => await getRealTimeValidationTextRes('real_time_validation_has_char'),
    has_case: async(type) => {
        const tpl = await getRealTimeValidationTextRes('real_time_validation_has_case')
        return formatMessage(tpl, {type})
    },
    like_email: async() => await getRealTimeValidationTextRes('real_time_validation_like_email'),
    digits: async(length) => {
        const tpl = await getRealTimeValidationTextRes('real_time_validation_digits')
        return formatMessage(tpl, {length})
    },
    is_same: async(match) => {
        const tpl = await getRealTimeValidationTextRes('real_time_validation_is_same')
        return formatMessage(tpl, {match})
    }
}

export default text
